import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';

@Component({
  selector: 'modal-content-title',
  templateUrl: './modal-content-title.component.html',
  styleUrls: ['modal-content-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalContentTitleComponent {
  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;

  @Input() public contentTitle: string;
}
